<template>
  <div class="AIDrawer">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="70%"
      top="5vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
    >
      <div class="dialog-content">
        <el-row class="wh100" :gutter="20">
          <el-col
            :span="12"
            class="h100"
            style="border-right: 1px solid #e4e4e4"
          >
            <div class="h">设备信息</div>
            <el-descriptions class="margin-top" :column="1" border>
              <el-descriptions-item>
                <template slot="label"> 设备编号 </template>
                {{ devInfo.DeviceCode || row.DeviceItemCode || '' }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label"> 设备名称 </template>
                {{ devInfo.device_name || row.DeviceItemName || '' }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label"> 安装位置 </template>
                {{ devInfo.InstallationAreaName || '' }}
              </el-descriptions-item>
            </el-descriptions>
            <div>
              <div class="title">描述说明</div>
              <el-input
                style="border-radius: 20px"
                type="textarea"
                placeholder="请输入内容"
                rows="20"
                resize="none"
                v-model="textarea"
              ></el-input>
              <div style="text-align: right; margin: 20px 0">
                <el-button
                  type="primary"
                  @click="AIop"
                  icon="el-icon-s-tools"
                  :loading="loading"
                  >生成</el-button
                >
              </div>
            </div>
          </el-col>
          <el-col
            :span="12"
            class="h100 AIlo"
            v-loading="loading"
            element-loading-text="AI拼命生成中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            element-loading-customClass="AIlo"
          >
            <div class="h">建议描述</div>
            <quill-editor
              ref="myQuillEditor"
              v-model="value"
              :options="editorOption"
              style="height: calc(100% - 120px); padding-bottom: 70px"
              v-if="value !== ''"
            />
            <el-empty
              :image="shengcheng"
              description="请在左侧输入您的描述说明，
AI将在此处显示建议描述。"
              v-if="value === ''"
            ></el-empty>
            <div
              style="height: 40px; text-align: right; margin-top: 20px"
              v-if="value !== ''"
            >
              <el-button
                type="primary"
                @click="AIYes"
                icon="el-icon-circle-check"
                :loading="loading"
                >应用</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import shengcheng from '@/assets/shengcheng.png'
export default {
  data() {
    return {
      shengcheng,
      devInfo: {},
      editorOption: {
        theme: 'snow', // 主题
        placeholder: '',
        AIshow: false,

        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ header: 1 }, { header: 2 }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ script: 'sub' }, { script: 'super' }],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ direction: 'rtl' }],
              [{ size: ['small', false, 'large', 'huge'] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ['clean', 'link'],
            ], // 自定义工具栏选项
          },
        },
      },
      textarea: '',
      title: 'AI建议生成',
      dialogVisible: false,
      row: [],
      value: '',
      RecordId: '',
      loading: false,
    }
  },
  props: {},
  components: {},
  methods: {
    AIYes() {
      this.dialogVisible = false
      this.$emit('AI', this.value)
    },
    AIop() {
      if (this.textarea === '') {
        return this.$notify.error('请先输入描述说明后生成')
      }
      this.getInfo()
    },
    getInfo() {
      this.loading = true

      this.$http
        .post('/Base_DeviceTreeManage/Device_Fault/AIFaultResult', {
          devicequery: this.textarea || '',
          BillId: this.row.Id,
          BillType: 'Repair',
          Recordld: this.RecordId,
        })
        .then((res) => {
          this.loading = false
          if (res.Success) {
            let data = JSON.parse(res.Data)
            this.RecordId = data.RecordId
            this.value = data.AiResult
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
    DevInfo() {
      this.$http
        .post('/PB/PB_Project/GetProjectDevceList', {
          Search: [
            {
              Condition: 'Id',
              Keyword: this.row.DeviceItemId,
            },
          ],
        })
        .then((res) => {
          if (res.Success) {
            this.devInfo = res.Data[0]
          }
        })
    },
    open(row) {
      this.dialogVisible = true
      this.row = { ...row }
      this.textarea = this.row.FaultDescription || ''
      this.value = ''
      this.RecordId = ''
      this.DevInfo()
      console.log(row)
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
.dialog-content {
  width: 100%;
  height: calc(90vh - 120px);
  overflow-y: auto;
  .title {
    font-size: 18px;
    font-weight: bold;
    margin: 20px 0;
  }
  ::v-deep .el-textarea__inner {
    border-radius: 15px;
    color: #000;
  }
  .h {
    font-size: 18px;
    font-weight: bold;
    line-height: 20px;
    margin: 10px 0;
  }
}
::v-deep .AIlo {
  .el-icon-loading {
    font-size: 50px;
  }
  .el-loading-text {
    font-size: 24px;
  }
}
</style>
